/* Ash Cooper: no preselected size on the product page. The Pre-order now button stays full strength;
   if it is pressed before a size is chosen, the "Choose your size" hint is highlighted and focus moves to the sizes.
   Skipped when the URL already names a variant (?variant=). */
(() => {
  if (!/\/products\//.test(location.pathname)) return;
  if (new URLSearchParams(location.search).has('variant')) return;
  const init = () => {
    const picker = document.querySelector('variant-picker');
    if (!picker) return;
    const radios = picker.querySelectorAll('input[type="radio"]');
    if (!radios.length) return;
    radios.forEach((r) => { r.checked = false; r.removeAttribute('checked'); r.dataset.currentChecked = 'false'; });
    let chosen = false;
    const hint = document.createElement('p');
    hint.className = 'ac-size-hint';
    hint.setAttribute('role', 'status');
    hint.setAttribute('aria-live', 'polite');
    hint.textContent = 'Choose your size';
    picker.appendChild(hint);
    const guard = (e) => {
      if (chosen) return;
      const btn = e.target.closest && e.target.closest('.add-to-cart-button, .sticky-add-to-cart__button, button[name="add"]');
      if (!btn && e.type === 'click') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      hint.classList.remove('ac-size-hint--alert');
      void hint.offsetWidth;
      hint.classList.add('ac-size-hint--alert');
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const first = picker.querySelector('input[type="radio"]:not([data-option-available="false"])') || radios[0];
      first.focus({ preventScroll: true });
    };
    document.addEventListener('click', guard, true);
    document.addEventListener('submit', (e) => { if (!chosen && e.target.closest('product-form-component, .product-form, form[action*="/cart/add"]')) guard(e); }, true);
    picker.addEventListener('change', () => { chosen = true; hint.remove(); }, { once: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
